export const NODE_NAME = 'file';
